import { render } from "./DjFrequencyLimitTab.vue?vue&type=template&id=06a23a34&scoped=true"
import script from "./DjFrequencyLimitTab.vue?vue&type=script&lang=js"
export * from "./DjFrequencyLimitTab.vue?vue&type=script&lang=js"

import "./DjFrequencyLimitTab.vue?vue&type=style&index=0&id=06a23a34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06a23a34"

export default script